import React, { ReactNode } from 'react';
import { TabPanel, TabPanelProps } from 'primereact/tabview';

export type TabViewProps = TabPanelProps & {
  children: ReactNode;
};

export const TabView = (props: TabViewProps): JSX.Element => {
  return <TabPanel {...props}>{props.children}</TabPanel>;
};
